import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useConfig } from '@common/Hooks/useConfig';
import SlidePanelHeadline from '@common/SlidePanel/components/SlidePanelHeadline';
import { isBooztletAndWebshop } from '@helpers/env';
import { isFeatureActive } from '@helpers/index';
import { getTranslatedPropertyFromContext } from '@helpers/translationContext';
import MenuItem from './MenuItem';
import './MenuListItem.scss';

const getProductCount = (currentNavItem, { productCount }) => {
    if (currentNavItem && currentNavItem.lvl > 1) {
        return productCount;
    }

    if (typeof App !== 'undefined' && isBooztletAndWebshop) {
        return productCount;
    }

    return '';
};

function MenuListItem({
    imagesSourceUrl,
    items,
    urlPrefix = '',
    liModifier = '',
    currentNavItem = {},
    type = 'default',
    menuItemClick = null,
    selectedMenuItem = '',
    theme,
    isUsingRouter
}) {
    const config = useConfig();
    const isMobileNavRefresh = isFeatureActive('PLT-34079_mobile_nav_refresh_2023', config);
    const currentTree = items;
    const menuItems = Object.keys(currentTree).map((index, itemIndex) => {
        const item = currentTree[index];
        const {
            children, hasArrow, resource, highlight
        } = item;
        const hasArrowValue = typeof hasArrow !== 'undefined'
            ? hasArrow
            : (children && Object.keys(children).length > 0);
        const {
            badge,
            content,
            rightContent,
            rightIcon,
            theme: itemTheme,
            idNameSlug
        } = item;
        const itemProps = {
            badge,
            hasArrow: hasArrowValue,
            index,
            idNameSlug,
            productCount: getProductCount(currentNavItem, item),
            liModifier,
            anchorModifier: item.cssClassLink || '',
            urlPrefix: typeof item.URLPrefix !== 'undefined' ? item.URLPrefix : urlPrefix,
            onClick: menuItemClick,
            text: getTranslatedPropertyFromContext(item, 'name', config),
            subText: item.subText,
            url: item.url,
            attributes: item.attributes ? item.attributes : {},
            isActive: index === selectedMenuItem,
            icon: item.icon,
            content,
            rightContent,
            rightIcon,
            theme: itemTheme,
            imagesSourceUrl,
            resource,
            highlight,
            isUsingRouter
        };

        if (type === 'mobile_nav' && !isMobileNavRefresh
            && ['mod3', 'mod4', 'mod5', 'mod6', 'mod7', 'mod9', 'mod10', 'mod11', 'mod12'].indexOf(itemTheme) === -1) {
            itemProps.hasArrow = itemTheme !== 'mod2';
            itemProps.productCount = '';
        }

        if (item.cssClass) {
            itemProps.liModifier += ` ${item.cssClass}`;
        }

        if (typeof item.is_new !== 'undefined') {
            itemProps.isNew = item.is_new;
        }

        if (item.navigationId === 93583) {
            itemProps.isExternal = true;
        }

        // Override main click callback if current item has its own
        if (typeof item.onClick === 'function') {
            itemProps.onClick = item.onClick;
        }

        let Component = (
            <MenuItem
                key={index}
                {...itemProps}
            />
        );

        if (item.type === 'menu_headline') {
            const isFirst = itemIndex === 0;
            let headlineTheme;

            if (isMobileNavRefresh) {
                headlineTheme = 'mod13';
            } else if (isFirst && theme !== 'mod2') {
                headlineTheme = 'mod1';
            } else {
                headlineTheme = 'mod3';
            }

            Component = (
                <SlidePanelHeadline
                    key={index}
                    theme={headlineTheme}
                >
                    {item.name}
                </SlidePanelHeadline>
            );
        }

        return Component;
    });

    return <div className={classNames('menu-list', theme && `menu-list--${theme}`)}>{menuItems}</div>;
}

// Typechecking
MenuListItem.propTypes = {
    items: PropTypes.object.isRequired
};

export default MenuListItem;
